
<template>
  <div class="man-orders">
    <CustomTitle title="绩效排名" :month="ym" style="margin-bottom:22px" />
    <template v-if="performanceData && performanceData.length">
      <ManSortitem
        ref="ManSortitem"
        v-for="(item, index) in performanceData.slice(0, 3)"
        :key="'top-' + index"
        :item="formatItem(item, index + 1)"
        :index="index + 1"
        :maxNumber="maxDisHours"
      />
      <div class="scroll-chart">
        <vue-seamless-scroll
          :data="performanceData"
          class="warp"
          :class-option="classOption"
          :limitMoveNum="8"
        >
          <ManSortitem
            v-for="(item, index) in performanceData.slice(3)"
            :key="'scroll-' + index"
            :item="formatItem(item, index + 4)"
            :index="index + 4"
            :maxNumber="maxDisHours"
          />
        </vue-seamless-scroll>
      </div>
    </template>
    <div v-else class="no-data">暂无数据</div>
  </div>
</template>

<script>
import CustomTitle from '@/components/CustomTitle'
import ManSortitem from '@/components/ManSortitem'  // 确保导入路径正确
import vueSeamlessScroll from 'vue-seamless-scroll'
import moment from 'moment'

export default {
  name: 'PerformanceRanking',
  components: {
    CustomTitle,
    ManSortitem,  // 确保组件已注册
    vueSeamlessScroll
  },
  data() {
    return {
      performanceData: [], // 存储绩效数据
      timer: null, // 用于每小时请求一次接口
      requestFunTimer: null, // 每秒钟执行一下判断时间方法
      switchTimer: null, // 每两分钟切换一下月和周的数据
      dataType: 'month', // 目前展示的数据的类型
      ym: new Date().getMonth() + 1 + ' 月',
      componentHeight: 0,
      classOption: {
        singleHeight: 30
      },
      nowDate: '', // 当前是多少号
      requestUrl: '',
      maxDisHours: 0, // 最大工时，用于计算比例
      lastUpdateTime: '' // 最后更新时间
    }
  },
  computed: {
    // 计算最大工时
    computedMaxDisHours() {
      return this.performanceData.length > 0 
        ? Math.max(...this.performanceData.map(item => item.DisHours)) 
        : 0
    }
  },
  methods: {
    // 格式化数据项
    formatItem(item, index) {
      return {
        name: `${item.Proset}件${item.ACTPrice}元`,
        pg: item.ACTPrice,
        value: item.DisHours,
        client: item.Processor1,
        rank: index
      }
    },
    
    // 初始化定时器
    initTimer() {
      // 清除现有定时器
      if (this.timer) {
        clearInterval(this.timer)
      }
      
      // 每小时获取一次数据
      this.timer = setInterval(() => {
        this.fetchPerformanceData()
      }, 60 * 60 * 1000) // 每小时一次
      
      // 立即获取一次数据
      this.fetchPerformanceData()
    },
    
    // 获取绩效数据
    async fetchPerformanceData() {
      try {
        const compid = window.localStorage.getItem('bsmcompid')
        const dept = window.localStorage.getItem('bsmdept')
        const qatec = window.localStorage.getItem('QATecIPQCFlag') || 1
        
        const response = await this.axios({
          method: 'get',
          url: `${this.requestUrl}/admin.php/Bigsreen/PerformanceSortFun?dept=${dept}&QATecIPQCFlag=${qatec}&compid=${compid}`
        })
        
        let data = JSON.parse(response.data)
        
        // 按 DisHours 降序排序
        data = data.sort((a, b) => b.DisHours - a.DisHours)
        
        // 更新数据
        this.performanceData = data
        this.maxDisHours = this.computedMaxDisHours
        this.lastUpdateTime = moment().format('YYYY-MM-DD HH:mm:ss')
        
        // 更新组件高度
        this.$nextTick(() => {
          if (this.$refs.ReceivingOrderItem && this.$refs.ReceivingOrderItem[0]) {
            const componentHeight = this.$refs.ReceivingOrderItem[0].$el.offsetHeight
            this.classOption = { singleHeight: componentHeight }
          }
        })
      } catch (error) {
        console.error("获取绩效数据失败:", error)
      }
    },
    
    // 时间检查方法
    checkTime() {
      const currentHour = moment().hour()
      
      // 工作时间段 (8:00 - 21:00)
      if (currentHour >= 8 && currentHour < 21) {
        if (!this.timer) {
          this.initTimer()
        }
      } else {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    }
  },
  created() {
    this.requestUrl = window.localStorage.getItem('requestUrl')
    
    // 初始化时间检查
    this.checkTime()
    this.requestFunTimer = setInterval(this.checkTime, 1000)
    
    // 设置月份显示
    const currentDate = moment().date()
    if (currentDate >= 4) {
      this.ym = moment().format('M月')
    } else {
      this.ym = moment().subtract(1, 'months').format('M月')
    }
  },
  beforeDestroy() {
    // 清除所有定时器
    if (this.timer) clearInterval(this.timer)
    if (this.requestFunTimer) clearInterval(this.requestFunTimer)
    if (this.switchTimer) clearInterval(this.switchTimer)
  },

}
</script>

<style scoped lang="less">
.man-orders {
  display: flex;
  flex-direction: column;
  height: 100%;

  .scroll-chart {
    flex: 1;
    height: 0;
    min-height: 100px;
    overflow: hidden;
    .warp {
      height: 100%;
    }
  }
  
  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #999;
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/workroomdp/components/Mansort.vue